import React from "react";
import "./compatible_with.scss";
import { Text, Icon } from '@ui-kit';
import { map } from 'underscore';
const Ai = '/images/icons/integrations/ai.svg';
const Sketch = '/images/icons/integrations/sketch.svg';
const Figma = '/images/icons/integrations/figma.svg';
const Ps = '/images/icons/integrations/ps.svg';
const Question = '/images/icons/help-circle-gray400.svg';

const CompatibleWith = ({compatibility_draw = []}) => {

  const renderIcon = (flag) =>{
    switch (flag) {
      case 'illustrator':
        return Ai;

      case 'photoshop':
        return Ps;

      case 'figma':
        return Figma;

      case 'sketch':
        return Sketch;

      default: 
        return Question;
    }
  }
 
    return (
        <div className="info__compatible mb-20 d-flex ai-center">
        <Text as="h5" className="info__header mr-8">Compatible with:</Text>
        {map(compatibility_draw, (item, index) => (
          <div key={`compatible-${index}`} className="info__content mr-8 d-flex ai-center">
            <Icon src={renderIcon(item)} />
          </div>
        ))}
      </div>
    )
}

export default CompatibleWith;